import { useFormikContext } from 'formik';

import { IconButton } from '../../../cdl/IconButton/IconButton';
import { FormikProductSelect } from '../../../common/form-elements/formik/FormikProductSelect';
import { FormikFormattedNumberInput } from '../../../common/FormattedNumberInput/FormikFormattedNumberInput';
import { formatNumber } from '../../../common/helpers/formatNumber.helper';
import { translate } from '../../../common/helpers/translate.helper';
import { useEnums } from '../../../common/hooks/useEnums';
import { IconX } from '../../../common/icons/cdl/X';
import { Td } from '../../../common/Table/Td';
import { Tr } from '../../../common/Table/Tr';
import type { PriceCompareFormValues } from '../types/PriceCompareFormValues';
import { calculatePriceCompareItem } from '../utils/calculatePriceCompareItem';
import { updatePriceCompareItemProduct } from '../utils/updatePriceCompareItemProduct';

import { FormikPriceComparePackTypeSelect } from './FormikPriceComparePackTypeSelect';

interface ItemsTableRowProps {
    index: number;
    onRemove: () => void;
    showRemoveIcon: boolean;
}

export const ItemsTableRow = ({ index, onRemove, showRemoveIcon }: ItemsTableRowProps) => {
    const { getHumanReadableValue } = useEnums();
    const { values, setFieldValue } = useFormikContext<PriceCompareFormValues>();
    const item = values.items[index];
    const itemName = `items[${index}]`;
    const computedItem = calculatePriceCompareItem(item);
    const productGroup = item.group ? getHumanReadableValue('productGroup', item.group) : null;

    return (
        <Tr>
            <Td>
                <FormikProductSelect
                    name={`${itemName}.productId`}
                    placeholder={translate('compare.placeholder.product')}
                    onSelect={(product) => setFieldValue(itemName, updatePriceCompareItemProduct(item, product))}
                />
            </Td>
            <Td>{productGroup}</Td>
            <Td>
                <FormikPriceComparePackTypeSelect name={itemName} item={item} />
            </Td>
            <Td>{formatNumber({ number: item.unitSize, maximumFractionDigits: 3 })}</Td>
            <Td>
                <FormikFormattedNumberInput
                    name={`${itemName}.units`}
                    placeholder={translate('placeholder.quantity')}
                    decimalScale={0}
                    allowNegativeValue={false}
                />
            </Td>
            <Td>{computedItem.volume ? formatNumber({ number: computedItem.volume }) : null}</Td>
            <Td>{item.unit ? getHumanReadableValue('productUnit', item.unit) : null}</Td>
            <Td>
                {showRemoveIcon ? (
                    <IconButton
                        type="button"
                        Icon={IconX}
                        onClick={onRemove}
                        tooltipLabel={translate('compare.remove')}
                    />
                ) : null}
            </Td>
        </Tr>
    );
};
